<h1>
  <button *ngIf="showBackButton" class="back-button" mat-icon-button matSuffix [routerLink]="routerLink"
          (click)="forwardClickEvent()">
    <mat-icon>arrow_back</mat-icon>
  </button>{{headline}}<button *ngIf="showEditButton" class="edit-button" mat-icon-button matSuffix [routerLink]="editRouterLink"
                               (click)="forwardEditClickEvent()">
  <mat-icon>edit</mat-icon>
</button>
</h1>
